import { useState } from "react";

export const useLocalStorage = (keyName, defaultValue = null) => {
  const getCircularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    };
  };
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.localStorage.getItem(keyName);
      if (value === null || value === "undefined") {
        window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
        return defaultValue;
      }
      return JSON.parse(value);
    } catch (err) {
      console.warn(`Error parsing localStorage key "${keyName}":`, err);
      return defaultValue;
    }
  });
  const setValue = (newValue) => {
    try {
      const toStore = newValue === undefined ? defaultValue : newValue;
      window.localStorage.setItem(keyName, JSON.stringify(toStore));
      setStoredValue(toStore);
    } catch (err) {
      console.log("error setting value", err);
    }
  };
  return [storedValue, setValue];
};
